import {
    Drawer,
    Button,
    Card,
    Header,
    Text,
    Icons,
    useDrawer,
} from "../../design";
import { translate, translateLocalizedEntity } from "../../utils/translations";
import { useLoopAuth } from "../auth-provider";
import { useLoyalty } from "../loyalty-provider";
import LoyaltyDiscountsDrawerFriendbuy from "./loyalty-fb-discounts";
import LoyaltyPointsDrawerFriendbuy from "./loyalty-fb-points";

function LoyaltyOverviewDrawerFriendbuy(props: any) {
    const { friendbuyData } = useLoyalty();
    const { storeId } = useLoopAuth();

    const drawers = useDrawer();

    const toggleDiscountsDrawer = () => {
        drawers.open({
            component: LoyaltyDiscountsDrawerFriendbuy,
            props: {},
        });
    };
    const togglePointsDrawer = () => {
        drawers.open({
            component: LoyaltyPointsDrawerFriendbuy,
            props: {
                entity: props.entity
            },
        });
    };

    return (
        <Drawer
            title={
                translateLocalizedEntity(
                    "CP_THEME_ADVENT_LOYALTY_FB",
                    storeId,
                    "loyalty_overview_drawer_header_fb",
                    translate("loyalty_overview_drawer_header_fb"),
                )
            }
            active={props.active}
            toggleActive={props.toggleActive}
            id="loyalty-overview"
        >
            <Drawer.Body>
                <div className="d-flex flex-align-items-center justify-content-center">
                    <Card className="flex-fill me-1">
                        <Card.Body>
                            <Text.P1>
                                {
                                translateLocalizedEntity(
                                    "CP_THEME_ADVENT_LOYALTY_FB",
                                    storeId,
                                    "loyalty_overview_points_title_fb",
                                    translate("loyalty_overview_points_title_fb"),
                                )
                                }
                            </Text.P1>
                            <Header.H2>{friendbuyData.points}</Header.H2>
                        </Card.Body>
                    </Card>
                    <Card className="flex-fill ms-1">
                        <Card.Body>
                            <Text.P1>
                                {
                                translateLocalizedEntity(
                                    "CP_THEME_ADVENT_LOYALTY_FB",
                                    storeId,
                                    "loyalty_overview_coupons_title_fb",
                                    translate("loyalty_overview_coupons_title_fb"),
                                )
                                }
                            </Text.P1>
                            <Header.H2>{friendbuyData.couponCount}</Header.H2>
                        </Card.Body>
                    </Card>
                </div>
                {friendbuyData.couponCount > 0 && (
                    <Card
                        className="flex-fill my-2"
                        onClick={toggleDiscountsDrawer}
                    >
                        <Card.Body className="d-flex align-items-center">
                            <div className="flex-fill">
                                <Header.H3>
                                    {
                                        translateLocalizedEntity(
                                            "CP_THEME_ADVENT_LOYALTY_FB",
                                            storeId,
                                            "loyalty_overview_discount_btn_fb",
                                            translate("loyalty_overview_discount_btn_fb"),
                                        )
                                    }
                                </Header.H3>
                                <Text.P2 className="loop-text-muted">
                                    {
                                        translateLocalizedEntity(
                                            "CP_THEME_ADVENT_LOYALTY_FB",
                                            storeId,
                                            "loyalty_overview_discount_btn_subtitle_fb",
                                            translate("loyalty_overview_discount_btn_subtitle_fb"),
                                            { coupons: friendbuyData.couponCount }
                                        )
                                    }
                                </Text.P2>
                            </div>
                            <Icons.RightChevron />
                        </Card.Body>
                    </Card>
                )}
                {friendbuyData.points > 0 && (
                    <Card
                        className="flex-fill my-2"
                        onClick={togglePointsDrawer}
                    >
                        <Card.Body className="d-flex align-items-center">
                            <div className="flex-fill">
                                <Header.H3>
                                    {
                                        translateLocalizedEntity(
                                            "CP_THEME_ADVENT_LOYALTY_FB",
                                            storeId,
                                            "loyalty_overview_redeem_btn_fb",
                                            translate("loyalty_overview_redeem_btn_fb"),
                                        )
                                    }
                                </Header.H3>
                                <Text.P2 className="loop-text-muted">
                                    {
                                        translateLocalizedEntity(
                                        "CP_THEME_ADVENT_LOYALTY_FB",
                                        storeId,
                                        "loyalty_overview_redeem_btn_subtitle_fb",
                                        translate("loyalty_overview_redeem_btn_subtitle_fb"),
                                        { points: friendbuyData.points }
                                    )
                                  }
                                </Text.P2>
                            </div>
                            <Icons.RightChevron />
                        </Card.Body>
                    </Card>
                )}
                <div
                    dangerouslySetInnerHTML={{
                        __html: 
                        translateLocalizedEntity(
                            "CP_THEME_ADVENT_LOYALTY_FB",
                            storeId,
                            "loyalty_overview_description_fb",
                            translate("loyalty_overview_description_fb", {}),
                        )
                    }}
                ></div>
            </Drawer.Body>
            <Drawer.Footer>
                <div className="d-flex flex-column">
                    <Button
                        size="lg"
                        variant="underline"
                        className="m-2"
                        onClick={props.toggleActive}
                    >
                        {
                            translateLocalizedEntity(
                                "CP_THEME_ADVENT_LOYALTY_FB",
                                storeId,
                                "loyalty_overview_drawer_go_back_btn_fb",
                                translate("loyalty_overview_drawer_go_back_btn_fb"),
                            )
                        }
                    </Button>
                </div>
            </Drawer.Footer>
        </Drawer>
    );
}
export default LoyaltyOverviewDrawerFriendbuy;
